// extracted by mini-css-extract-plugin
export default {"cardBg2Links":"style_cardBg2Links__RGfs3"};